// Legend.js
import React, { useEffect } from "react";
import L from "leaflet";
import { useMap } from "react-leaflet";
import { useTranslation } from "react-i18next";

const Legend = ({ selectedParameter, colorMapping }) => {
  const map = useMap();
  const { t } = useTranslation();
  useEffect(() => {
    if (!map || !selectedParameter || !colorMapping[selectedParameter]) return;

    const legend = L.control({ position: "topright" });

    legend.onAdd = () => {
      const div = L.DomUtil.create("div", "info legend");

      // Add custom styling for better visibility
      div.style.backgroundColor = "rgba(255, 255, 255, 0.8)";
      div.style.padding = "10px";
      div.style.borderRadius = "8px";
      div.style.boxShadow = "0 2px 6px rgba(0, 0, 0, 0.3)";
      div.style.fontSize = "14px";
      div.style.lineHeight = "1.5";

      const labels = colorMapping[selectedParameter].map(({ color, label }) =>
        `<i style="background: ${color}; width: 12px; height: 12px; display: inline-block; margin-right: 8px;"></i> ${label}`
      );

      // Title mapping
      let title;
      switch (selectedParameter.toLowerCase()) {
        case "ndvi":
          title = t("Crop Health");
          break;
        case "ndre":
          title = t("Fertilizer Content");
          break;
        case "ndmi":
          title = t("Moisture Content");
          break;
        case "msavi":
          title = t("Germination & Initial Growth");
          break;
        case "ncc":
          title = t("Natural Image");
          break;
        default:
          title = t(`${selectedParameter}`);
      }



      // Title and color labels
      div.innerHTML = `<h4 style="margin: 0 0 8px 0; font-weight: bold;">${title} ${t("Levels")}</h4>` + labels.join("<br>");
      return div;
    };

    legend.addTo(map);
    return () => {
      legend.remove();
    };
  }, [map, selectedParameter, colorMapping]);

  return null;
};

export default Legend;